'use strict';

export let ArticuloComponent = {
    selector: 'articulo',
    template: require('./articulo.html'),
    transclude: true,
    scope: true,
    bindings: {
        articulo: '<'
    }
};



// WEBPACK FOOTER //
// ./client/components/articulo/articulo.component.js